<template>
  <div id="warranty-registration-container">
    <div
      id="warranty-register-intro"
      class="support-subject-intro"
    >Thank you for purchasing our product ! For warranty valid, please help to fill the following information.</div>
    <div id="warranty-register-wrapper" class="support-form-wrapper">
      <div class="support-form-title text-center text-uppercase">Register Information</div>
      <v-form ref="form" v-model="validForm" lazy-validation>
        <div id="warranty-resgier-form-wrapper">
          <v-row dense>
            <v-col cols="12" md="6">
              <div class="support-form-label">First Name</div>
              <v-text-field
                v-model="firstName"
                outlined
                autocomplete
                color="#333333"
                class="support-form-field"
                required
                dense
                :rules="firstNameRule"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <div class="support-form-label">Last Name</div>
              <v-text-field
                v-model="lastName"
                single-line
                outlined
                autocomplete
                color="#333333"
                class="support-form-field"
                required
                :rules="lastNameRule"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <div class="support-form-label">Email Address</div>
              <v-text-field
                v-model="email"
                single-line
                outlined
                autocomplete
                color="#333333"
                class="support-form-field"
                required
                :rules="emailAddressRule"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <div class="support-form-label">Amazon Order Id</div>
              <v-text-field
                v-model="amazonOrderId"
                autocomplete
                single-line
                outlined
                color="#333333"
                class="support-form-field"
                :rules="amazonOrderIdRule"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <div class="support-form-label">Product</div>
              <v-select
                color="#333333"
                v-model="warrantyRegisterProduct.registerdProduct"
                :items="warrantyRegisterProduct.productTypes"
                outlined
                :rules="warrantyRegisterProduct.rules"
              ></v-select>
              <v-checkbox dense :rules="agreeTermAndConditionRule" color="#e2211c">
                <template v-slot:label>
                  <div id="agree-to-warranty-term-section" class="font-italic font-size-14">
                    I agree to 1byone health warranty's
                    <a
                      target="_blank"
                      href="/support/warranty"
                      @click.stop
                    >term and condition</a>
                  </div>
                </template>
              </v-checkbox>
            </v-col>
          </v-row>
        </div>
        <div id="warranty-registration-submit-button" class="text-center mt-2">
          <v-btn
            :disabled="!validForm"
            @click="submit"
            color="#e2211c"
            outlined
            width="400px"
            height="40px"
            :loading="customeServiceRequestSending"
          >Submit Registration</v-btn>
        </div>
      </v-form>
    </div>
  </div>
</template>


<script>
import {
  firstNameRule,
  lastNameRule,
  emailAddressRule,
  amazonOrderIdRule,
  agreeTermAndConditionRule,
  productTypeSelectionRule
} from "../../utils/formRulesCheck";

import { registerProductWarranty } from "../../api/dataFactory";
import customerServiceMixins from "../../mixins/customerServiceMixins";

export default {
  mixins: [customerServiceMixins],
  metaInfo: {
    title: "Warranty product register | 1byone health",
    meta: [
      {
        vmid: "description",
        name: "description",
        content:
          "1byone health gives user free support,30-day money-back guarantee for any reason, and 12-month warranty for quality-related issues."
      },
      {
        vmid: "keywords",
        name: "keywords",
        content:
          "1byone, 1byone health, 1byonehealth, warranty, product warranty,30-day money-back guarantee,12-month warranty gurantee warranty, free replacement,free support"
      }
    ]
  },
  data: () => ({
    firstNameRule,
    lastNameRule,
    emailAddressRule,
    amazonOrderIdRule,
    agreeTermAndConditionRule,
    validForm: true,
    registeredProduct: "",
    firstName: "",
    lastName: "",
    email: "",
    amazonOrderId: "",
    warrantyRegisterProduct: {
      registerdProduct: "",
      productTypes: ["scales", "bp monitor"],
      rules: productTypeSelectionRule
    },
    customeServiceRequestSending: false
  }),

  methods: {
    async submit() {
      if (this.$refs.form.validate()) {
        this.customeServiceRequestSending = true;
        let request = this.buildProductWarrantyRegistrationRequest();
        let result = await registerProductWarranty(request);
        this.customeServiceRequestSending = false;
        if (result) {
          this.$emit(
            "onCustomerServiceRequestSubmitted",
            true,
            "Your product warranty registration is submitted, we will contact you shortly via email"
          );
        } else {
          this.$emit(
            "onCustomerServiceRequestFailed",
            true,
            "There is problem when submitting the request. Please try again later"
          );
        }
      }
    },

    buildProductWarrantyRegistrationRequest() {
      let request = new FormData();
      request.append("lastName", this.firstName);
      request.append("firstName", this.lastName);
      request.append("email", this.email);
      request.append("amazonOrderId", this.amazonOrderId);
      request.append(
        "productName",
        this.warrantyRegisterProduct.registerdProduct
      );
      request.append("recognizedUserEmail", this.recognizedUserEmail);
      return request;
    }
  }
};
</script>


<style scoped>
#agree-to-warranty-term-section,
a {
  color: #999999 !important;
}

a {
  border-bottom: 1px solid #999999;
}
</style>